
import {of, Observable} from 'rxjs';
import { share } from 'rxjs/operators';

import {map, flatMap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {AppSettingsService, AuthenticationService, BaseService, ServiceManager,} from 'iui-iconectiv-lib';

import {GenericResponse, QueryPaging} from '..';
import {FeeScheduleResponse} from "../model";

const FEE_SCHEDULE_LIST = '/api/feeschedule/list';

@Injectable()
export class FeeScheduleService extends BaseService {

  cachedFees: Observable<FeeScheduleResponse>;

  constructor(serviceManager: ServiceManager,
              private http: HttpClient,
              private appSettings: AppSettingsService,
              private authService: AuthenticationService,) {

    super(serviceManager);
  }

  /**
   * Retrieve the account data
   */
  getFeeScheduleList(): Observable<FeeScheduleResponse> {
    if (this.cachedFees) {
      return this.cachedFees;
    }

    this.cachedFees = this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
        const url = this.getServer(settings) + FEE_SCHEDULE_LIST;

        return this.http.get(url, {
          headers: new HttpHeaders()
            .append('Content-Type', 'application/json')
            .append('Authorization', this.authService.getToken()),
          responseType: 'text'
        }).pipe(
          map(res => {
            const r = this.parseToType<FeeScheduleResponse>(res)
            this.cachedFees = of(r);
            return r;
          }))
      }
    ))).pipe(share());
    return this.cachedFees;
  }
}
